import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useRideDetailsCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        RideDetailsPage: {
          heroBackground: {
            sizes: {
              small_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              medium_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              large_url: {
                url: '/imgs/Rebranding/petterns/asphalt.png',
              },
            },
            alt: 'Asphalt background',
          },
          reserveBtnLable: t('ride_details:reserve'),
          mapGroupTitle: t('ride_details:motorcycle_rental_locations'),
          mapGroupSubTitle: t('ride_details:location_for'),
          locationSearchInputPlaceholder: t('ride_details:Search_by_location_name'),
          eagleRider:  t('ride_details:eagle_rider'),
          motorcycleRide:  t('ride_details:motorcycle_ride'),
          shareModalTitle: t('ride_details:share_the_ride'),
          aboutRideTitle:t('ride_details:about_ride'),

        },
         ShareLinkComponent: {
          shareText: t('common_share:share'),
          shareJourney: t('common_share:share_journey'),
          blueRidgeAdventure: t('common_share:blue_ridge_adventure'),
          copyLink: t('common_share:copy_link'),
          whatsApp: t('common_share:whats_app'),
          facebook: t('common_share:facebook'),
          email: t('common_share:email'),
          linkCopiedText: t('common_share:link_copied'),
        },
        ParticipatingLocationsComponent: {
          searchInputPlaceholder: t(
            'common_participating_locations:find_location_by_name',
          ),
          participatingLocationsTitle: t(
            'common_participating_locations:participating_locations',
          ),
          contactUsDialogTitle: t('common_participating_locations:contact_er'),
          showMapBtnText: t('common_participating_locations:show_map'),
          otherLocationsTitle: t(
            'common_participating_locations:other_locations',
          ),
          adressLabel: t('common_participating_locations:address'),
          callButtonLabel: t('common_participating_locations:call'),
          emailButtonLabel: t('common_participating_locations:email'),
          locationButtonLabel: t(
            'common_participating_locations:location_details',
          ),
        },
         GalleryComponent: {
          showAllMedia: t('common_gallery:show_photos'),
        },
        NewMainWidgetComponent: {
          rentMotorcycle: t('common_new_main_widget:rent_motorcycle'),
          allMotorcycleTours: t('common_new_main_widget:all_motorcycle_tours'),
          guidedMotorcycleTours: t('common_new_main_widget:guided_motorcycle_tours'),
          selfDriveMotorcycleTours: t('common_new_main_widget:self_drive_motorcycle_tours'),
          returnToSameLocation: t('common_new_main_widget:return_to_same_location'),
          searchTour: t('common_new_main_widget:search_tour'),
          tourTypeLabel: t('common_new_main_widget:tour_type'),
          countryLabel: t('common_new_main_widget:country_label'),
          stateNameLabel: t('common_new_main_widget:state_name_label'),
          tourTabLabel: t('common_new_main_widget:tour_tab_label'),
          rentalTabLabel: t('common_new_main_widget:rental_tab_label'),
          country: t('common_new_main_widget:country'),
          stateName: t('common_new_main_widget:state_name'),
          futureBookings: t('common_new_main_widget:future_bookings'),
          saveEvenMore: t('common_new_main_widget:save_even_more'),
          rideRoundTripOrOneWay: t('common_new_main_widget:can_ride_rounded_trip_or_one_way'),
          startYourReservation: t('common_new_main_widget:start_your_reservation'),
          pickupLocation: t('common_new_main_widget:pickup_location'),
          choosePickupLocation: t('common_new_main_widget:choose_pickup_location'),
          dropoffLocation: t('common_new_main_widget:dropoff_location'),
          chooseDropoffLocation: t('common_new_main_widget:choose_dropoff_location'),
          sameAsPickupLocation: t('common_new_main_widget:same_as_pickup_location'),
          dropoffLocationError: t('common_new_main_widget:dropoff_location_error'),
          pickupDateLabel: t('common_new_main_widget:pickup_date_label'),
          dropoffDateLabel: t('common_new_main_widget:dropoff_date_label'),
          milesAway: t('common_new_main_widget:miles_away'),
          baseErrorHeader: t('common_new_main_widget:base_error_header'),
          warning: t('common_new_main_widget:warning'),
          warningNote: t('common_new_main_widget:warning_note'),
          saveUpTo: t('common_new_main_widget:save_up_to'),
          closedAlertText: t('common_new_main_widget:closed_alert'),
          timeLabel: t('common_new_main_widget:time'),
          reserveBtnLabel: t('common_new_main_widget:reserve'),
          vehiclesLabel: t('common_new_main_widget:vehicles'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useRideDetailsCMSData };
